import React from 'react'
import { Heading } from '@myxplor/ui'

const NoPersonnel = () => <Heading small>No Personnel found</Heading>

export default NoPersonnel



// WEBPACK FOOTER //
// ./src/personnel/views/empty.jsx